<template lang="pug">
  .snooze-notifications-view
    .snooze-notifications-table-wrapper
      SnoozeNotificationsTable(
        :sensor="soilSensor"
        :chartData="sensorInfos"
        :chartType="chartType"
        :datetime="dateRange"
        :snoozeNotifications="snoozeNotifications"
        :loading="loading"
      )
      .pagination
        PaginationShared(
          :view="'snooze_notifications'"
          :activeName="'snooze_notifications'"
          :search="search"
          @modalData="handleGetNotifications"
          @handleTableLoading="handleLoading"
        )
</template>

<script>
import { filterUtils } from "@utils/filterUtils";
import SnoozeNotificationsTable from "@components/client/notifications/SnoozeNotificationsTable";
import PaginationShared from "@components/_shared/PaginationShared";
import { mapActions, mapMutations, mapState } from "vuex";
import { general } from "@src/services/dynamicViews/general";
export default {
  name: "ManageSnoozeNotifications",
  mixins: [filterUtils, general],

  components: {
    SnoozeNotificationsTable,
    PaginationShared,
  },

  data() {
    return {
      loading: false,
      loadingBtn: false,
      selectedFieldId: "",
      transmitterId: "",
      infoType:"",
      search: "",
      chartType: null,
      sensorInfos: null,
      generatePausedForSeconds: false,
      reload: false,
      dateRange: [],
      transmitters: [],
      soilSensors: [],
      snoozeNotifications: [],
      resetKey: null,
      fieldsInfoSettings: [],
      fieldName: "",
      statuses: [
        { name: "Not seen", value: 'not_seen' },
        { name: "All", value: 'all' },
        { name: "Seen", value: 'seen' }
      ],
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("soilSensor", ["soilSensor"]),
    ...mapState("field", ["selectedField", "selectedFieldInfoSettings"]),

  },

  created(){
    if(this.selectedField && this.selectedField != "all"){
      this.selectedFieldId = this.selectedField.id.toString();
    }      
    else {
      this.selectedFieldId = "all";
    }
  },

  mounted() {
    this.checkMobile();
      window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMobile);
  },

  watch: {
    selectedField(){
      if(this.selectedField && this.selectedField != "all"){
        this.selectedFieldId = this.selectedField.id.toString();
      }
      else {
        this.selectedFieldId = "all";
      }
    },

    async soilSensor() {
      await this.handleGetField();
      await this.handleChange(this.dateRange);
    },

    // async reload(val) {
    //   if (val) {
    //     this.handleLoading(true);
    //     await this.handleChange(this.dateRange);
    //     this.handleLoading(false);
    //   }
    // }
  },

  methods: {
    ...mapActions('sensorInfo', ['getSoilSensorInfo']),
    ...mapActions("field", ["getFieldInfoSettings"]),
    ...mapActions("transmitter", ["getTransmitter"]),
    ...mapActions("notification", ["updateNotifications"]),

    ...mapMutations("notification", ["setShouldFetchNotifications"]),
    ...mapMutations("dialog", ["showManageSnoozeNotificationsDialog"]),

    checkMobile() {
      this.isMobile = window.innerWidth <= 1400;
    },

    handleGetTransmitters(data) {
      this.transmitters = data;
    },

    handleGetSoilSensors(data) {
      this.soilSensors = data;
    },

    handleGetNotifications(data) {
      this.snoozeNotifications = data;
    },

    async markAllAsSeen() {
      this.loadingBtn = true;
      await Promise.all(this.notifications.map(n =>
        this.updateNotifications(n.id, { seen: true })
      ));
      this.setShouldFetchNotifications(true);
      this.loadingBtn = false;
    },

    handleLoading(loading) {
      this.loading = loading;
      // if(!loading) {
      //   setTimeout(() => this.generatePausedForSeconds = loading, 2000);
      // }else {      
      //   this.generatePausedForSeconds = loading;
      // }
      // this.reload = false;
    },

    reloadData(){
      this.resetKey = Date.now();
      this.reload = true;
    },

    handlePaginationLoading(loading) {
      this.loading = loading
    },

    async handleChange(values) {
      let computedParams;
      if(this.soilSensor) {
        if (values && values.length > 0) {
          let dateRangeComputed = {
            start_date: values[0],
            end_date: values[1],
          };
          this.dateRange = [dateRangeComputed.start_date, dateRangeComputed.end_date];
          computedParams = `?by_soil_sensor_id=${this.soilSensor.id}&by_date_range[start_date]=${dateRangeComputed.start_date}&by_date_range[end_date]=${dateRangeComputed.end_date}`;

          const response = await this.getSoilSensorInfo(computedParams);
          this.sensorInfos = response;
        } 
        else {
          this.sensorInfos = [];
        }
      }
    },

    async handleGetField(){
      const transmitterResponse = await this.getTransmitter(this.soilSensor.sensor_transmitter.id);

      if( transmitterResponse.data && transmitterResponse.data.field) {
        let fieldId = transmitterResponse.data.field.id;
        this.fieldName = transmitterResponse.data.field_name;
        const response = await this.getFieldInfoSettings(`?by_field_id=${fieldId}`);

        this.fieldsInfoSettings = response.data.map((item) => ({
          id: item.id,
          info_type: item.info_type || '',
          info_type_unit: item.info_type_unit || '',
          range1s: parseFloat(item.range1s) || 0,
          range1e: parseFloat(item.range1e) || 0,
          range1color: item.range1color || '',
          range2s: parseFloat(item.range2s) || 0,
          range2e: parseFloat(item.range2e) || 0,
          range2color: item.range2color || '',
          range3s: parseFloat(item.range3s) || 0,
          range3e: parseFloat(item.range3e) || 0,
          range3color: item.range3color || ''
        }));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@variables";

.container {

  @media (max-width: 1400px) {
    flex-direction: column;

    .notifications-table-wrapper {
      width: 100%;

      .notifications-wrapper {
        display: grid;
        grid-template-rows: auto;
        grid-template-areas: 
        "header"
        "main"
        "footer";
        width: 100%;
        max-width: 1200px; // limit table area expansion

        .actions {
          grid-area: header;
          width: 100%;
          display: grid;
          padding: 15px;
        }

        .table-wrapper {
          grid-area: main;
          width: 100%;
          overflow-x: scroll;
          max-width: 650px;
          // margin: 0 auto; // centers the table inside grid area
        }

      }
    }


  }
}
</style>